import "@/index.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import About from "@/pages/About";
import Articles from "@/pages/Articles";
import ArticleDetail from "@/pages/ArticleDetail";
import FaqPage from "@/pages/FaqPage";
import Contact from "@/pages/Contact";
import { Privacy, Terms } from "@/pages/Legal";
import Consultants from "@/pages/Consultants";
import ConsultantPage from "@/pages/ConsultantPage";

const NotFound = () => (
  <section className="wrap py-32" data-testid="not-found">
    <title>Halaman tidak ditemukan | Mika Solution</title>
    <p className="eyebrow">404</p>
    <h1 className="mt-6 font-display text-5xl font-extrabold">Halaman tidak ditemukan.</h1>
    <Link to="/" className="btn btn-slate mt-10" data-testid="not-found-home">Kembali ke Beranda</Link>
  </section>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/layanan/:slug" element={<ServicePage />} />
          <Route path="/tentang-kami" element={<About />} />
          <Route path="/konsultan" element={<Consultants />} />
          <Route path="/konsultan/:slug" element={<ConsultantPage />} />
          <Route path="/artikel" element={<Articles />} />
          <Route path="/artikel/:slug" element={<ArticleDetail />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/kontak" element={<Contact />} />
          <Route path="/kebijakan-privasi" element={<Privacy />} />
          <Route path="/syarat-ketentuan" element={<Terms />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
